import { Ref } from 'react';

interface Props {
  name?: string;
  text?: string;
  textRef?: Ref<HTMLSpanElement>;
}

const MacroRowLabel = ({ name, text, textRef }: Props) => (
  <>
    <span className="text-sm leading-none font-medium text-foreground">{name}</span>
    <span ref={textRef} className="line-clamp-2 text-sm leading-5 text-muted-foreground">
      {text}
    </span>
  </>
);

export default MacroRowLabel;
